import {Injectable} from '@angular/core';
import {Constant} from '../../global/util/Constant';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {Tenor} from '../model/Tenor';

@Injectable({
  providedIn: 'root'
})
export class TenorService {

  private url = Constant.ROOT_API_V1.concat('/tenor');

  constructor(private http: HttpClient) {
  }

  public save(tenor: Tenor): Observable<any> {
    return this.http.post(this.url, JSON.stringify(tenor), Headers.contentType);
  }

  public update(tenor: Tenor): Observable<any> {
    return this.http.put(this.url, JSON.stringify(tenor), Headers.contentType);
  }

  public getBy(workflowId: number) {
    const url = Constant.ROOT_API_V1
      .concat('/workflow/')
      .concat(String(workflowId))
      .concat('/tenor');
    return this.http.get(url);
  }
}
